export const getImageLoading = (index) => (index < 3 ? "eager" : "lazy");

export const handleImageError = (event, fallbackSrc) => {
  if (fallbackSrc && event?.target) {
    event.target.src = fallbackSrc;
    return;
  }
  if (event?.target) {
    event.target.style.display = "none";
  }
};
